import React from 'react';

// What a panel shows while the account (or both ends of an arrow) is loading.
const PanelSkeleton = () => (
  <div className="rounded-lg border border-ui-divider-lines bg-white p-5">
    {[0, 1, 2].map((i) => (
      <div
        key={i}
        className="mb-3 h-4 w-48 animate-pulse rounded bg-teal-t30"
      />
    ))}
  </div>
);

export default PanelSkeleton;
